// src/index.tsx
import * as React from "react";

var DefaultComp = _ref => {
  let {
    type
  } = _ref;
  throw new Error("Could not find a component mapping for type \"".concat(type, "\""));
};

var MapToComponents = _ref2 => {
  let {
    getKey,
    getType,
    list,
    map,
    meta,
    mapDataToContext,
    mapDataToProps,
    default: Default = DefaultComp,
    defaultMapDataToContext,
    defaultMapDataToProps
  } = _ref2;
  if (!list) return null;
  const keys = list.map(getKey);
  const types = list.map(getType);
  const comps = types.map(type => {
    var _map$type;

    return (_map$type = map[type]) !== null && _map$type !== void 0 ? _map$type : Default;
  });

  const gatherData = index => ({
    list,
    keys,
    types,
    comps,
    map,
    meta,
    index,
    data: list[index],
    key: keys[index],
    type: types[index],
    Comp: comps[index],
    previousData: list[index - 1],
    previousKey: keys[index - 1],
    previousType: types[index - 1],
    PreviousComp: comps[index - 1],
    nextData: list[index + 1],
    nextKey: keys[index + 1],
    nextType: types[index + 1],
    NextComp: comps[index + 1]
  });

  const contexts = list.map((_, index) => {
    var _ref3;

    const fn = (_ref3 = mapDataToContext == null ? void 0 : mapDataToContext[types[index]]) !== null && _ref3 !== void 0 ? _ref3 : defaultMapDataToContext;
    return fn ? fn(gatherData(index)) : void 0;
  });

  const gatherDataForMapDataToProps = index => ({ ...gatherData(index),
    contexts,
    context: contexts[index],
    previousContext: contexts[index - 1],
    nextContext: contexts[index + 1]
  });

  const propsList = list.map((_, index) => {
    var _ref4;

    const fn = (_ref4 = mapDataToProps == null ? void 0 : mapDataToProps[types[index]]) !== null && _ref4 !== void 0 ? _ref4 : defaultMapDataToProps;
    return fn ? fn(gatherDataForMapDataToProps(index)) : void 0;
  });
  return /* @__PURE__ */React.createElement(React.Fragment, null, propsList.map((mappedProps, index) => {
    const Comp = comps[index];
    const type = types[index];
    const isDefault = Comp === Default;

    if (isDefault) {
      return /* @__PURE__ */React.createElement(Default, {
        key: keys[index],
        type,
        ...mappedProps
      });
    }

    return /* @__PURE__ */React.createElement(Comp, {
      key: keys[index],
      ...mappedProps
    });
  }));
};

export { MapToComponents };